
/* injects from baggage-loader */

import OncaGraphBarsModule from './onca-graph-bars/onca-graph-bars.module';
import TamanduaCanvasModule from './tamandua-canvas/tamandua-canvas.module';

const shared = angular.module('ui-module', [
  OncaGraphBarsModule.name,
  TamanduaCanvasModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/ui/index.js